import type { VFC } from 'react';

import classNames from 'classnames';
import { Cancel as CancelIcon } from '@vgno/icons';

import { Button } from '../Button/Button';

import * as styles from './Chip.module.scss';

export interface ChipProps {
  label: string;
  isActive?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

const Chip: VFC<ChipProps> = ({ label, isActive, onClick, loading }) => {
  return (
    <Button
      size="small"
      variant="contained"
      rounded
      role="tab"
      aria-selected={isActive}
      onClick={onClick}
      isActiveBrandColor={isActive}
      disabled={loading}
      className={classNames({ [styles.loading]: loading })}
    >
      {label}
      {isActive && <CancelIcon className={styles.close} />}
    </Button>
  );
};

export { Chip };
